// src/services/serviceStatus.js
import proxyapi from './ProxyApi';

export const getServiceStatus = async () => {
  try {
    console.log('Attempting to fetch system status from /api/v1/system/status');
    const response = await proxyapi.get('/api/v1/system/status'); // Use publicApi instead of proxyapi
    console.log('Response received:', response);
    return response.data;
  } catch (error) {
    console.error('Error fetching service status:', error);
    console.error('Error details:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      config: error.config
    });
    // Default to service up in case of error (to prevent false negatives)
    return { serviceDown: false };
  }
};

export const isServiceAvailable = async () => {
  const status = await getServiceStatus();
  return !status.serviceDown;
};